<template>
    <div>
        <Modal v-model="modal" :title="modelTitle" width="700px" :closable="false" :mask-closable="false">
            <div>
                <!-- {{achievementItem}} -->
                <Form ref="achievementItemFormValidate" :model="achievementItem" :rules="achievementItemRuleValidate" :label-width="140">
                    <FormItem label="项目时间">
                        <DatePicker v-model="dateVal" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="请选择" style="width: 100%;" :editable="false"></DatePicker>
                    </FormItem>

                    <!-- <DatePicker :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="Select date" style="width: 200px"></DatePicker> -->

                    <FormItem label="演出项目名称" prop="projectName">
                        <Input v-model.trim="achievementItem.projectName" placeholder="请输入演出项目名称"></Input>
                    </FormItem>
                    <FormItem label="项目中担任职务" prop="job">
                        <Input v-model.trim="achievementItem.job" placeholder="请输入项目中担任职务"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" @click="handleConfirm">确认</Button>
                <Button type="primary" @click="handleCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: {
        achievementItem: {
            type: Object,
            default: {},
        },
        modelTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            value2: [],

            modal: false,
            achievementItemRuleValidate: {
                projectName: [
                    {
                        required: true,
                        message: "演出项目名称不可为空",
                        trigger: "blur",
                    },
                ],
                job: [
                    {
                        required: true,
                        message: "项目中担任职务不可为空",
                        trigger: "blur",
                    },
                ],
            },
            dateVal: [],
        };
    },
    watch: {
        modal(val, oldVal) {
            if (this.modelTitle == "修改项目") {
                this.dateVal = this.achievementItem.projectTime.split("-");
                return;
            }
            if (val) {
                this.$refs["achievementItemFormValidate"].resetFields();
                this.dateVal = [];
                this.achievementItem.projectTime = "";
                this.achievementItem.uniquId = "";
            }
        },
    },
    methods: {
        handleCancel() {
            this.modal = false;
        },

        handleConfirm() {
            this.$refs["achievementItemFormValidate"].validate((valid) => {
                if (valid) {
                    if (this.dateVal.length == 0) {
                        this.$Modal.warning({
                            title: "提示信息",
                            content: "请选择项目时间",
                            okText: "关闭",
                        });
                        return;
                    }
                    this.achievementItem.projectTime =
                        moment(new Date(this.dateVal[0])).format("YYYY/MM/DD") +
                        "-" +
                        moment(new Date(this.dateVal[1])).format("YYYY/MM/DD");
                    console.log("this.achievementItem", this.achievementItem);
                    // return
                    this.$emit("getAchievementItem", this.achievementItem);
                    this.modal = false;
                }
            });
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/wumeigeren/components/ModalAchievement.vue